import { capitalize } from "@mui/material"
import { convertDateTime } from "lib/utils.ts"
import { DriverInfo, VehicleInfo } from "types/list-card-holder"
import { DriverIcon } from "layouts/card-holder/drivers/icons.tsx"
import { CardHolderNameCell } from "layouts/card-holder/table/cardHolderNameCell.tsx"
import React, { ReactNode } from "react"
import { CardHolderAutochargeCell } from "../table/cardHolderAutochargeCell.tsx"

export enum CardHolderMode {
  Driver = "driver",
  Vehicle = "vehicle",
}

export const ROW_HEADER_KEYS = {
  [CardHolderMode.Driver]: "name",
  [CardHolderMode.Vehicle]: "description",
} as const

export const COLUMN_WIDTH = {
  titleDriver: "20%",
  titleVehicle: "15%",
  status: "10%",
  createdAt: "20%",
  lastName: "15%",
  firstName: "15%",
  email: "20%",
  cards: "10%",
  description: "25%",
  autocharge: "10%"
} as const

export type TableColumn<T> = {
  key: keyof T
  label: string
  centered?: boolean
  icon?: ReactNode
  width: string
  renderCell: (data: T) => ReactNode
}

export const driverColumns: TableColumn<DriverInfo>[] = [
  {
    key: "name",
    label: "Conducteur",
    icon: React.createElement(DriverIcon),
    width: COLUMN_WIDTH.titleDriver,
    renderCell: (data) => React.createElement(CardHolderNameCell, { driver: data }),
  },
  {
    key: "active",
    label: "Statut",
    width: COLUMN_WIDTH.status,
    renderCell: (data) => capitalize(data.active ? "Actif" : "Inactif"),
  },
  {
    key: "createdAt",
    label: "Date de création",
    width: COLUMN_WIDTH.createdAt,
    renderCell: (data) => convertDateTime(data.createdAt),
  },
  {
    key: "lastName",
    label: "Nom",
    width: COLUMN_WIDTH.lastName,
    renderCell: (data) => capitalize(data.lastName ?? ""),
  },
  {
    key: "firstName",
    label: "Prénom",
    width: COLUMN_WIDTH.firstName,
    renderCell: (data) => capitalize(data.firstName ?? ""),
  },
  {
    key: "email",
    label: "Email",
    width: COLUMN_WIDTH.email,
    renderCell: (data) => data.email ?? "",
  },
  {
    key: "numberOfCards",
    label: "Cartes",
    centered: true,
    width: COLUMN_WIDTH.cards,
    renderCell: (data) => data.numberOfCards,
  },
]

export const vehicleColumns: TableColumn<VehicleInfo>[] = [
    {
        key: "description",
        label: "Nom du véhicule",
        width: COLUMN_WIDTH.description,
        renderCell: (data) =>
            React.createElement(CardHolderNameCell, { driver: data }),
    },
    {
        key: "licensePlate",
        label: "Plaque d'immatriculation",
        width: COLUMN_WIDTH.titleVehicle,
        renderCell: (data) => data.licensePlate ?? "",
    },
    {
        key: "active",
        label: "Statut",
        width: COLUMN_WIDTH.status,
        renderCell: (data) => capitalize(data.active ? "Actif" : "Inactif"),
    },
    {
        key: "createdAt",
        label: "Date de création",
        width: COLUMN_WIDTH.createdAt,
        renderCell: (data) => convertDateTime(data.createdAt),
    },
    {
        key: "autocharge",
        label: "Autocharge",
        centered: true,
        width: COLUMN_WIDTH.status,
        renderCell: (data) =>
            React.createElement(CardHolderAutochargeCell, { driver: data }),
    },
    {
        key: "numberOfCards",
        label: "Nombre de cartes",
        centered: true,
        width: COLUMN_WIDTH.cards,
        renderCell: (data) => data.numberOfCards,
    },
]

export function getColumns(isVehicle: boolean) {
    if (isVehicle) {
        return vehicleColumns
    } else {
        return driverColumns
    }
}

export const isRowHeader = (
  key: string,
  isVehicle: boolean,
): boolean => key === (isVehicle ? ROW_HEADER_KEYS[CardHolderMode.Vehicle] : ROW_HEADER_KEYS[CardHolderMode.Driver])